import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getCommissions(params) {
    return axios.get(adminPath('/commissions?') + prepareQueryString(params)).then((response) => {
      return {
        commissions: response.data.map((commission) => an('Commission', commission)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getLocationCommissions(locationId, params) {
    return axios.get(adminPath(`/locations/${locationId}/commissions?`) + prepareQueryString(params)).then((response) => {
      return {
        commissions: response.data.map((commission) => an('Commission', commission)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/commissions/${id}`)).then((response) => an('Commission', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/commissions/${id}`), {
        ...data,
      })
      .then((response) => an('Commission', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/commissions'), {
        ...data,
      })
      .then((response) => an('Commission', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/commissions.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
};
